module.exports = __webpack_public_path__ + "static/media/unknown-woman.1bbf1309.svg";